import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Shares the two pieces of context that cannot be derived from the URL alone:
 * - locale: full IETF code (e.g. 'de-DE') needed by the DSW footer
 * - availableLanguages: list from backend config, needed by the language switcher
 */
@Injectable({ providedIn: 'root' })
export class ProductContextService {
  private localeSubject = new BehaviorSubject<string>('');
  locale$ = this.localeSubject.asObservable();

  private availableLanguagesSubject = new BehaviorSubject<string[]>([]);
  availableLanguages$ = this.availableLanguagesSubject.asObservable();

  setLocale(locale: string) {
    this.localeSubject.next(locale);
  }

  setAvailableLanguages(languages: string[]) {
    this.availableLanguagesSubject.next(languages);
  }
}
